export default __webpack_public_path__ + "static/media/garlicFest.4dfd480b.png";